import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class Student extends MongoEntity {
  static override _class = 'Student';
  static override _collectionName = 'students';

  @Field(() => String)
  firstName!: string;

  @Field(() => String)
  lastName!: string;

  @Field(() => String)
  school!: string;

  /**
   * Free-text subject/course/class names the student added themselves — unlike Teacher.subjects,
   * not restricted to the fixed Subject enum, since a student may take any number of arbitrary
   * courses/classes rather than "teaching" a fixed curriculum.
   */
  @Field(() => [String])
  subjects!: string[];

  @Field(() => String)
  email!: string;

  @Field(() => String)
  passwordHash!: string;

  @Field(() => String)
  userID!: string;

  @Field(() => String)
  language?: string;
}
